import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["maRow", "preview"]

  connect() {
    // Update all previews on load
    this.updateAllPreviews()
  }

  // Update preview when color or period changes
  updatePreview(event) {
    const row = event.target.closest('[data-chart-settings-form-target="maRow"]')
    if (!row) return

    this.updateRowPreview(row)
  }

  // Update all preview badges
  updateAllPreviews() {
    this.maRowTargets.forEach(row => {
      this.updateRowPreview(row)
    })
  }

  // Update a single row's preview badge
  updateRowPreview(row) {
    const period = row.querySelector('[name*="[period]"]')?.value
    const type = row.querySelector('[name*="[type]"]')?.value?.toUpperCase()
    const color = row.querySelector('[name*="[color]"]')?.value
    const badge = row.querySelector('[data-chart-settings-form-target="preview"]')

    if (badge && period && type) {
      badge.style.backgroundColor = color
      badge.textContent = `${period} ${type}`
    }
  }
}
